export const convertName = (req) => {
    switch (req) {
        case 'kullaniciAdi':
            return 'Kullanıcı Adı';
        case 'kullaniciSifre':
            return 'Şifre';
        case 'vergiNumarasi':
            return 'Vergi Numarası';
        case 'veritabaniAd':
            return 'Veritabanı Adı';
        case 'donemYil':
            return 'Dönem Yılı';
        case 'apiKullaniciAdi':
            return 'API Kullanıcı Adı';
        case 'apiKullaniciSifre':
            return 'API Kullanıcı Şifresi';
        case 'username':
            return 'Kullanıcı Adı';
        case 'password':
            return 'Şifre';

        default:
            return req;
    }
};

export const convertReq = (req) => {
    let copy = {};
    req.forEach((req) => {
        copy[req] = '';
    });

    return copy;
};
